import { Suspense } from 'react';

import { usePageLoaded } from '../../../hooks/usePageLoaded';

export const IsolatePageLoad: React.FC = () => {
	usePageLoaded();

	return <Suspense fallback={null} />;
};
